import Cookies from "js-cookie";
import OSS from "ali-oss";
import axiosApi from "@/request/index";
const TokenKey = "Token";

export function getToken() {
  return Cookies.get(TokenKey);
  // return "5ZGReyJkZXMiOiI4Y2Y1NjJjZTkzMGFkZmYwYWFiZDdjYzQyODBlZjI3ZiIsInRva2VuSW5mbyI6eyJhZG1pbkZsYWciOjEsImNydFRpbWUiOjE3MTUwNDQ3Mzg1MTEsImV4cGlyZVRpbWUiOjE3MjgwMDAwMCwidXNlcklkIjoyMDV9fQ";
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

// let client = new OSS({
//   region: "oss-cn-hangzhou",
//   accessKeyId: "LTAIAFEe1m0izOBK",
//   accessKeySecret: "R0NSWCfSHJGYWH6zW9H8Pc9Upma3Zk",
//   bucket: "product-lee-upload"
// });

export function uploadFile(file, topic, callBack, errorBack, fileName) {
  let fileResultName = file.name;
  if (fileName != null && fileName != undefined && fileName != "") {
    fileResultName = fileName;
  }
  let urlKey = topic + "/" + new Date().getTime() + "_" + fileResultName;
  axiosApi.tokenSTS().then(res => {
    let client = new OSS({
      region: "oss-cn-hangzhou",
      accessKeyId: res.content.credentials.accessKeyId,
      accessKeySecret: res.content.credentials.accessKeySecret,
      stsToken: res.content.credentials.securityToken,
      bucket: "product-lee-upload"
    });
    client
      .put(urlKey, file)
      .then(function(r1) {
        const url = r1.url;
        const urls = url.replace("http://", "https://");
        console.log("文件上传成功：", urls);
        callBack && callBack(urls);
      })
      .catch(function(err) {
        console.error("文件上传失败：", err);
        errorBack && errorBack(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/auth.js